import styled from 'styled-components';
export const StyledSearchWrapper = styled.div.withConfig({
  displayName: "StyledSearchWrapper",
  componentId: "sc-8bxgnn-0"
})(["box-shadow:rgba(0,0,0,0) 0px 0px 0px 0px;transform:translateZ(0);will-change:box-shadow,max-height;overflow:hidden;max-height:100%;", " &::before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background:#fbfbfb;transform:translateZ(0);will-change:opacity;opacity:", ";transition:", ";}"], ({
  isOpen,
  theme
}) => isOpen && `
      box-shadow: 0 0 30px 13px rgb(0 0 0 / 20%);
      display: block !important;
      border-radius: ${theme.borderRadius['temp-future-300']};
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1311;
      max-height: 100vh;
      overflow: hidden !important;
      transition: box-shadow .2s ease, max-height .5s ease !important;
`, ({
  isOpen
}) => isOpen ? 1 : 0, ({
  isOpen
}) => isOpen ? `opacity .2s ease !important;` : '');